import React from 'react';
import ReactDOM from 'react-dom/client';
import ApiClient from './ApiClient';
import './style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

// get root dataset resource value, if not set, use 'events'
const resource = document.getElementById('root').dataset.resource ?? 'documents';

root.render(
    <React.StrictMode>
        <ApiClient resource={resource} />
    </React.StrictMode>
);
